import React from "react";

function Players() {
  return <h1>Players Page</h1>;
}

export default Players;
